import { createSlice } from '@reduxjs/toolkit';
import * as actions from './actions';

const initialState = {
    isGroupLoaded: false,
    groupList: [],

    isPatientGroupByIdLoaded: false,
    patientGroupListById: [],

    isAllPatientLoaded: false,
    patientList: [],

    isAllContactLoaded: false,
    contactList: []
}

const groupSlice = createSlice({
    name: 'grouplists', 
    initialState,
    extraReducers: (builder) => {

        builder.addCase(actions.getGroups.pending, (state) => {
            state.isGroupLoaded = false;
        })
        builder.addCase(actions.getGroups.fulfilled, (state, action) => {
            if (action.payload.success) {
                state.groupList = action.payload.data;
            } else {
                state.groupList = [];
            }
            state.isGroupLoaded = true;
        })
        builder.addCase(actions.getGroups.rejected, (state) => {
            state.isGroupLoaded = false;
        }); 

        //Delete group 
        builder.addCase(actions.deleteGroup.pending, (state) => {
            state.saving = true;
        })
        builder.addCase(actions.deleteGroup.fulfilled, (state, action) => {
            if (action.payload.success) {
                const id = action.payload.data;
                const enityIndex = state.groupList.findIndex(x => x.id === id);
                if (enityIndex > -1) {
                    state.groupList.splice(enityIndex, 1);
                }
            }
            state.isSaving = false;
        })
        builder.addCase(actions.deleteGroup.rejected, (state) => {
            state.isSaving = false;
        });

        // Save Interests
        builder.addCase(actions.saveGroup.pending, (state) => {
            state.isSaving = true;
        })
        builder.addCase(actions.saveGroup.fulfilled, (state, action) => {
            if (action.payload.success) {
                const returnObj = action.payload.data;
                state.groupList.unshift(returnObj);
            }
            state.isSaving = false;
        })

        builder.addCase(actions.saveGroup.rejected, (state) => {
            state.isSaving = false;
        });

        // Edit Interests
        builder.addCase(actions.editGroup.pending, (state) => {
            state.isSaving = true;
        })
        builder.addCase(actions.editGroup.fulfilled, (state, action) => {
            if (action.payload.success) {
                const returnObj = action.payload.data;
                const interestsObj = state.groupList.find(x => x.id === returnObj.id);
                if (interestsObj !== undefined && interestsObj !== null) {
                    interestsObj.name = returnObj.name;
                }
            }
            state.isSaving = false;
        })

        builder.addCase(actions.editGroup.rejected, (state) => {
            state.isSaving = false;
        });



        //PatientGroupListById

        builder.addCase(actions.getPatientGroupsById.pending, (state) => {
            state.isPatientGroupByIdLoaded = false;
        })
        builder.addCase(actions.getPatientGroupsById.fulfilled, (state, action) => {
            if (action.payload.success) {
                state.patientGroupListById = action.payload.data;
            } else {
                state.patientGroupListById = [];
            }
            state.isPatientGroupByIdLoaded = true;
        })
        builder.addCase(actions.getPatientGroupsById.rejected, (state) => {
            state.isPatientGroupByIdLoaded = false;
        }); 


        //Delete Patient from group
        builder.addCase(actions.deleteFromGroupByPatientid.pending, (state) => {
            state.saving = true;
        })
        builder.addCase(actions.deleteFromGroupByPatientid.fulfilled, (state, action) => {
            if (action.payload.success) {
                const id = action.payload.data;
                const indexToRemove = state.patientGroupListById.patients.findIndex(patient => patient.groupPatients.some(groupPatient => groupPatient.id === id));
                if (indexToRemove !== -1) {
                    const patient = state.patientGroupListById.patients[indexToRemove];
                    const groupPatientIndex = patient.groupPatients.findIndex(groupPatient => groupPatient.id === id);
                    if (groupPatientIndex !== -1) {
                        patient.groupPatients.splice(groupPatientIndex, 1);

                        // If the patient has no more groupPatients, remove the entire patient
                        if (patient.groupPatients.length === 0) {
                            state.patientGroupListById.patients.splice(indexToRemove, 1);
                        }
                    }
                }
            }
            state.isSaving = false;
        })
        builder.addCase(actions.deleteFromGroupByPatientid.rejected, (state) => {
            state.isSaving = false;
        });

        //getAllPatientList
        builder.addCase(actions.getPatientList.pending, (state) => {
            state.isAllPatientLoaded = false;
        })
        builder.addCase(actions.getPatientList.fulfilled, (state, action) => {
            if (action.payload.success) {
                state.patientList = action.payload.data;
            } else {
                state.patientList = [];
            }
            state.isAllPatientLoaded = true;
        })
        builder.addCase(actions.getPatientList.rejected, (state) => {
            state.isAllPatientLoaded = false;
        }); 

        //getAllContactsList
        builder.addCase(actions.getContactList.pending, (state) => {
            state.isAllContactLoaded = false;
        })
        builder.addCase(actions.getContactList.fulfilled, (state, action) => {
            if (action?.payload?.success) {
                state.contactList = action.payload.data;
            } else {
                state.contactList = [];
            }
            state.isAllContactLoaded = true;
        })
        builder.addCase(actions.getContactList.rejected, (state) => {
            state.isAllContactLoaded = false;
        }); 

    }
});

export default groupSlice.reducer;